<script>
    import {store} from '../../stores.js';

    const axis = store('axis', '', false);
    const cart = store('cart-items', '', '[]');

    export let args;

    // Используем let для обычной переменной
    let manualPrice = 0;
    let originalPrice = 0;

    // Обновляем рассчитанную цену при изменении args.selected или args.changed
    $: {
        if (!args.changed && args?.packing?.items?.length && args.selected) {
            const selectedItem = args.packing.items.find((el) => el.name === args.selected);
            if (selectedItem) {
                originalPrice = +(selectedItem.price * (args?.packing?.multiplier ?? 0)).toFixed(2);
                manualPrice = originalPrice; // Устанавливаем рассчитанную цену как текущую
            }
        }
    }

    $: price = manualPrice; // Используем manualPrice как итоговую цену

    $: selected = args?.selected ?? '';

    const change = () => {
        args.changed = true;
        // manualPrice уже обновляется через on:input
    };

    const select = ({target}) => {
        args.selected = selected = target.value;
        const item = args.packing.items.find((el) => el.name === args.selected);
        args.packing.item = item;
        args.changed = false;
        if (!args.changed) {
            const itemPrice = +(item.price * (args?.packing?.multiplier ?? 0)).toFixed(2);
            manualPrice = itemPrice;
            originalPrice = itemPrice;
        }
    };

    const add_packing = (idTovar, price, name = 'Упаковка') => {
        if ($axis) {
            let params = {
                idTovar: parseInt(idTovar),
                name: name,
                kolvo: 1,
                maxkolvo: 1,
                summa: parseFloat(price),
                summaRozn: parseFloat(price),
                summaDil: parseFloat(price),
                sebestoim: parseFloat(price),
            };

            window.top.postMessage('add_item::' + JSON.stringify(params), '*');
        } else {
            let data = ($cart || []);

            data.push({
                idTovar: parseInt(idTovar),
                type: 'упаковка',
                title: name,
                name: name,
                subname: '',
                quantity: 1,
                price: {
                    rozn: parseFloat(price),
                    opt: parseFloat(price),
                    sebest: parseFloat(price),
                },
            });

            cart.save(data);

            let popup = new bootstrap.Modal(document.getElementById('item-add'));
            popup.show();

            setTimeout(() => {
                popup.hide();

                document.querySelector('[data-bs-target="#cartPanel"]').click();
            }, 1500);
        }
    };

    // Вспомогательная функция для обновления manualPrice из input
    function handleInput(e) {
        const val = e.target.value;
        // Можно добавить проверку на валидность числа, если нужно
        manualPrice = val;
        change(); // Устанавливаем флаг, что цена была изменена
    }
</script>

{#if args.packing}
    <div class="card-body">
        <div class="row">
            <div class="col-12 col-md-4">
                <label class="form-label">Упаковка</label>
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <select class="form-control form-select" on:change={select} bind:value={selected}>
                            <option value="" disabled selected>Выберите вариант</option>
                            {#each args.packing.items as item}
                                <option value="{item.name}">{item.name}</option>
                            {/each}
                        </select>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-4">
                <label class="form-label">стоимость</label>
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <!-- Используем on:input для обновления manualPrice и value для отображения -->
                        <input
                                type="number"
                                class="form-control"
                                value={manualPrice}
                                on:input={handleInput}
                                on:change={change}
                                step="1"
                        >
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-4">
                <div class="form-group boxed">
                    <button
                            type="button"
                            class="btn btn-secondary btn-block"
                            on:click={() => add_packing(args.packing.item.idTovar, price, args.packing.item.name)}
                            disabled={!args.selected}
                    >
                        Добавить
                    </button>
                </div>
            </div>
        </div>
    </div>
{/if}